module.exports = __webpack_public_path__ + "img/BorrowAPR.065a148c.svg";